import { mapGraphQLProductToProduct } from '../../Theme'

import type { Product } from '../../UiBlocks'
import type { DiscountFactor, GraphQLProduct } from '../types'

/**
 * Map a GraphQL promo product to ProductCard Product interface
 * with computed promo discount price as specialPrice.
 *
 * @param graphqlProduct - Raw GraphQL product from category query
 * @param discountFactor - Multiplier for regular price (e.g., 0.3 = 70% off)
 * @returns Product with specialPrice set to promo price
 */
export function mapPromoProductToProduct(
  graphqlProduct: GraphQLProduct,
  discountFactor: DiscountFactor
): Product {
  const baseProduct = mapGraphQLProductToProduct(graphqlProduct)

  return {
    ...baseProduct,
    specialPrice: baseProduct.price * discountFactor,
  }
}
